var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesTools3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 72,
    viewBox: "0 0 84 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1325_14048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5771 71.4325C58.27 71.4325 73.4236 55.5686 73.4236 35.9995C73.4236 16.4303 58.27 0.566406 39.5771 0.566406C20.8841 0.566406 5.73047 16.4303 5.73047 35.9995C5.73047 55.5686 20.8841 71.4325 39.5771 71.4325Z",
    fill: "#F8F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3828 24.206H57.3776C55.9691 24.206 54.8164 22.9996 54.8164 21.5251V10.3098C54.8164 8.83533 55.9691 7.62891 57.3776 7.62891H80.3828C81.7912 7.62891 82.9439 8.83533 82.9439 10.3098V21.5251C82.9439 22.9996 81.7912 24.206 80.3828 24.206Z",
    fill: "#7D63EC",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3828 64.4169H57.3776C55.9691 64.4169 54.8164 63.2105 54.8164 61.7359V50.5207C54.8164 49.0463 55.9691 47.8398 57.3776 47.8398H80.3828C81.7912 47.8398 82.9439 49.0463 82.9439 50.5207V61.7359C82.9439 63.2105 81.7912 64.4169 80.3828 64.4169Z",
    fill: "#7D63EC",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6895 15.8952C61.6895 15.1548 62.2628 14.5547 62.97 14.5547H74.7929C75.5001 14.5547 76.073 15.1548 76.073 15.8952C76.073 16.6355 75.5001 17.2356 74.7929 17.2356H62.97C62.2628 17.2356 61.6895 16.6355 61.6895 15.8952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5156 56.1061C61.5156 55.3658 62.0885 54.7656 62.7957 54.7656H74.6185C75.3258 54.7656 75.8991 55.3658 75.8991 56.1061C75.8991 56.8461 75.3258 57.4465 74.6185 57.4465H62.7957C62.0885 57.4465 61.5156 56.8461 61.5156 56.1061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4304 10.834C49.9304 10.3105 49.1196 10.3105 48.6195 10.834C48.1195 11.3575 48.1195 12.2063 48.6195 12.7297L49.6775 13.8373H41.458C38.6594 13.8373 36.3789 16.2247 36.3789 19.1545V52.13C36.3789 55.0598 38.6594 57.4472 41.458 57.4472H49.6775L48.6195 58.555C48.1195 59.0782 48.1195 59.9269 48.6195 60.4502C49.1196 60.974 49.9304 60.974 50.4304 60.4502L53.6742 57.0549C53.9144 56.8031 54.0493 56.4623 54.0493 56.1068C54.0493 55.7513 53.9144 55.4103 53.6742 55.1589L50.4304 51.763C49.9304 51.2396 49.1196 51.2396 48.6195 51.763C48.1195 52.2865 48.1195 53.1353 48.6195 53.6588L49.6775 54.7663H41.458C40.0738 54.7663 38.9398 53.5791 38.9398 52.13V19.1545C38.9398 17.7054 40.0738 16.5182 41.458 16.5182H49.6775L48.6195 17.6257C48.1195 18.1492 48.1195 18.998 48.6195 19.5215C49.1196 20.0449 49.9304 20.0449 50.4304 19.5215L53.6742 16.1256C53.9144 15.8742 54.0493 15.5333 54.0493 15.1777C54.0493 14.8223 53.9144 14.4813 53.6742 14.2299L50.4304 10.834Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1978 38.2769H6.80078V35.6879H24.1978L23.096 34.5344C22.5959 34.0109 22.5959 33.1622 23.096 32.6387C23.5961 32.1152 24.4068 32.1152 24.9068 32.6387L28.1507 36.0346C28.6507 36.5581 28.6507 37.4068 28.1507 37.9303L24.9068 41.3261C24.4068 41.8496 23.5961 41.8496 23.096 41.3261C22.5959 40.8027 22.5959 39.9539 23.096 39.4304L24.1978 38.2769Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2701 45.2959H3.557C2.1485 45.2959 0.996094 44.0894 0.996094 42.6149V31.3997C0.996094 29.9252 2.1485 28.7188 3.557 28.7188H14.2701C15.6786 28.7188 16.831 29.9252 16.831 31.3997V42.6149C16.831 44.0894 15.6786 45.2959 14.2701 45.2959Z",
    fill: "#21C4C1",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0866 38.5468L39.5379 44.3555C38.4709 45.4726 36.7636 45.4726 35.6966 44.3555L30.148 38.5468C29.0809 37.4297 29.0809 35.6425 30.148 34.5254L35.6966 28.7167C36.7636 27.5996 38.4709 27.5996 39.5379 28.7167L45.0866 34.5254C46.1536 35.6425 46.1536 37.4297 45.0866 38.5468Z",
    fill: "#21C4C1",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1325_14048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTools3);
export default __webpack_public_path__ + "static/media/sales-tools-3.f73ab67802b446d7fba7fe0162d2fd19.svg";
export { ForwardRef as ReactComponent };